import { ReactElement } from "react";

export type HamburgerMenuIconProps = {
  showMenuIcon: boolean;
  expandMenu: boolean;
  onClick: () => void;
};

export function HamburgerMenuIcon({
  showMenuIcon,
  expandMenu,
  onClick,
}: HamburgerMenuIconProps): ReactElement {
  return (
    <>
      {showMenuIcon ? (
        <button onClick={onClick} aria-label="Hamburger-Menu">
          <span className="block w-6 h-0.5 my-1 bg-yellow-100 rounded-sm"></span>
          <span className="block w-6 h-0.5 my-1 bg-yellow-100 rounded-sm"></span>
          <span className="block w-6 h-0.5 my-1 bg-yellow-100 rounded-sm"></span>
        </button>
      ) : null}

      {expandMenu ? (
        <button onClick={onClick}>
          <span className="block w-6 h-0.5 my-1 bg-yellow-100 origin-100 rotate-45"></span>
          <span className="block w-6 h-0.5 my-1 bg-yellow-100 origin-100 -rotate-45"></span>
        </button>
      ) : null}
    </>
  );
}
